import { ProgressStepper, Separator, Text } from '@change/ds-core-ui/next';

import { Html } from 'src/app/shared/components/html';

import { PetitionMedia } from './components/PetitionMedia';
import { ShareActions } from './components/ShareActions';
import { ShareFeed } from './components/ShareFeed';
import { usePageBody } from './hooks/usePageBody';

export function PageBody() {
	const {
		data: { heading, subHeading, warning, shareFeed, pageTitle, hideStepperProgress },
	} = usePageBody();

	return (
		<div className="mx-auto max-w-[610px]">
			<PetitionMedia />
			<div className="bg-background-base elevation-elevated relative rounded-2xl py-7 md:py-9">
				<div className="flex flex-col gap-7 px-6 md:gap-9 md:px-10">
					<div className="flex flex-col justify-center gap-3 pb-3">
						{pageTitle && <Text className="text-center">{pageTitle}</Text>}
						{!hideStepperProgress && <ProgressStepper currentStepNumber={3} numberOfSteps={3} />}
					</div>
					<div className="flex flex-col gap-3 md:gap-4" data-qa="description">
						<Text size="medium" variant="heading" as="h1" className="m-0">
							{heading}
						</Text>
						<Text fontWeight="light" variant="body" className="text-typography-weak">
							<Html html={subHeading} noContentStyles />
						</Text>
						{warning && (
							<Text as="div" size="large" className="mt-4" data-qa="warning">
								<Html html={warning} noContentStyles />
							</Text>
						)}
					</div>

					<ShareActions />

					{shareFeed.showFeed && <Separator className="m-0" />}
				</div>

				{shareFeed.showFeed && (
					<div className="relative mt-7 h-full overflow-hidden md:mt-9">
						<ShareFeed items={shareFeed.items} data-qa="share-feed" />
					</div>
				)}
			</div>
		</div>
	);
}
